import styled from "styled-components";
import { size, palette } from "styled-theme";

const Wrapper = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.$esignstep === 0 ? "center" : "space-between"};
  margin: 50px 0 20px 0;

  .esign-back {
    font-size: ${size("p0")};
    background: none;
    color: ${palette("color", 26)};
    text-decoration: underline;
    padding: 0;
    text-align: left;

    &::before,
    &::after,
    &:focus {
      box-shadow: none;
    }
  }

  .esign-continue {
    font-size: ${size("p0")};

    &::before,
    &::after {
      content: none;
    }
  }

  .esign-download {
    text-align: left;
  }

  @media only screen and (min-width: ${size("S")}) {
    .esign-continue {
      width: 35%;
    }

    .esign-download {
      text-align: left;
    }
  }
`;

export default Wrapper;
